import template from 'url-template';

import {
    FETCH_PREVIEW_WEATHER_DATA,
    FETCH_CURRENT_SITE_WEATHER_DATA
} from '../actions/actionTypes';

import { get } from 'lodash';

import awsHeader from '../helpers/awsAuth';
import lambdaBaseApi from '../apis/lambda';

import { handleNetworkError } from './applicationMessageActions';
import { setBobLoading } from './bobActions';

const WeatherDataUrl = template.parse('/weatherdata{?endTimestamp,siteId,startTimestamp}');

export const fetchPreviewWeatherData = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    options.pageSize = 400;

    try {
        dispatch(setBobLoading('PreviewWeatherData'));
        const response = await lambdaBaseApi.get(
            WeatherDataUrl.expand({
                ...options
            }),
            header
        );

        const payload = get(response, 'data.data', []);

        dispatch({
            type: FETCH_PREVIEW_WEATHER_DATA,
            payload
        });
        dispatch(setBobLoading('PreviewWeatherData'));
        return true;
    } catch (error) {
        dispatch(setBobLoading('PreviewWeatherData'));
        dispatch(handleNetworkError(error));
        return false;
    }
};

export const fetchCurrentWeatherData = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    try {
        const response = await lambdaBaseApi.get(
            WeatherDataUrl.expand({
                ...options
            }),
            header
        );

        const payload = get(response, 'data.data', []);

        dispatch({
            type: FETCH_CURRENT_SITE_WEATHER_DATA,
            payload
        });
    }
    catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const setWeatherData = payload => async (dispatch, getState) => {
    dispatch({
        type: FETCH_PREVIEW_WEATHER_DATA,
        payload
    });
};
